import { forwardRef } from 'react'

import { IconProps, IconVariants } from '../IconVariants'
const StatusSuccessFilledIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size, ...props }, ref) => {
  return (
    <svg
      aria-hidden="true"
      className={IconVariants({
        class: className,
        size,
      })}
      ref={ref}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="12" cy="12" fill="#4caf50" r="10" />
      <path
        clipRule="evenodd"
        d="M17.7426 9.87274L10.6716 16.661L6.42893 12.588L7.84315 11.2304L10.6716 13.9447L16.3284 8.51509L17.7426 9.87274Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  )
})
StatusSuccessFilledIcon.displayName = 'StatusSuccessFilledIcon'
export default StatusSuccessFilledIcon
